(() => {
  const status = document.querySelector('[data-shopping-status]');
  document.addEventListener('ajaxProduct:added', () => {
    if (status) status.textContent = status.dataset.message;
  });
  const bar = document.querySelector('[data-shopping-sticky]');
  if (!bar) return;
  const source = document.querySelector('main .product-single__form [data-add-to-cart]');
  const trigger = bar.querySelector('[data-shopping-submit]');
  if (!source || !trigger || !window.IntersectionObserver) return;
  const mobile = window.matchMedia('(max-width: 768px)');
  const sync = () => {
    trigger.disabled = source.disabled || source.classList.contains('btn--loading');
    const rect = source.getBoundingClientRect();
    const defaultLabel = source.querySelector('[data-default-text]')?.dataset.defaultText;
    trigger.textContent = source.textContent.trim() === defaultLabel ? (rect.top >= window.innerHeight ? bar.dataset.choose : bar.dataset.add) : source.textContent.trim();
    const visible = rect.bottom > 0 && rect.top < window.innerHeight;
    bar.hidden = !mobile.matches || visible;
    document.body.classList.toggle('shopping-sticky-active', !bar.hidden);
  };
  new IntersectionObserver(sync).observe(source);
  new MutationObserver(sync).observe(source, { attributes: true, childList: true, subtree: true, characterData: true });
  mobile.addEventListener('change', sync);
  trigger.addEventListener('click', () => {
    if (source.getBoundingClientRect().top >= window.innerHeight) {
      const options = source.closest('[data-section-type]')?.querySelector('.variant-wrapper');
      (options || source).scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (!source.disabled) {
      source.click();
    }
  });
  sync();
})();
